module.exports = __webpack_public_path__ + "media/images/icon__infoBox--rb-gray-e72c2f5477a4a51a15343a3f11431691.png";